module.exports = __webpack_public_path__ + "img/house_29.5e8775f7.jpg";